import supportArticle, {
  QueryParameters,
} from "@faire/web-api/routes/support/articles/articleId";

import { useRetailerStore } from "@faire/retailer/stores/domain/RetailerStore";

const INSIDER_USA_HELP_CENTER_ARTICLE_ID = "4406840862747";
const INSIDER_EUROPE_HELP_CENTER_ARTICLE_ID = "4418050425115";
const INSIDER_AUSTRALIA_HELP_CENTER_ARTICLE_ID = "29367193374747";
const INSIDER_CANADIAN_HELP_CENTER_ARTICLE_ID = "29655338268315";
export const useInsiderHelpCenterArticleLink = (
  queryParams?: Partial<QueryParameters>
) => {
  const supportUrl = useInsiderHelpCenterURL();

  return supportArticle(supportUrl, queryParams);
};

const useInsiderHelpCenterURL = () => {
  const { isAmerican, isAustralian, isEurope, isCanadian } = useRetailerStore([
    "isAmerican",
    "isAustralian",
    "isEurope",
    "isCanadian",
  ]);

  if (isCanadian) {
    return INSIDER_CANADIAN_HELP_CENTER_ARTICLE_ID;
  }

  if (isAmerican) {
    return INSIDER_USA_HELP_CENTER_ARTICLE_ID;
  }
  if (isEurope) {
    return INSIDER_EUROPE_HELP_CENTER_ARTICLE_ID;
  }
  if (isAustralian) {
    return INSIDER_AUSTRALIA_HELP_CENTER_ARTICLE_ID;
  }
  return INSIDER_USA_HELP_CENTER_ARTICLE_ID;
};

export const useCancelInsiderMembershipHelpCenterArticleSectionAnchor = () => {
  const { isAmerican, isAustralian, isEurope, isCanadian } = useRetailerStore([
    "isAmerican",
    "isAustralian",
    "isEurope",
    "isCanadian",
  ]);

  if (isAmerican || isCanadian) {
    return "11";
  }
  if (isEurope) {
    return "10";
  }
  if (isAustralian) {
    return "9";
  }
  return undefined;
};
